import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eae2f78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topban" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zhengque" }, "正确答案为C")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xijun" }, null, -1))
const _hoisted_4 = { id: "about2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xuxian" }, " 研究表明，细菌感染是引起湿疹皮炎的重要原因，尤其是金黄色葡萄球菌感染促进了疾病的发生、发展 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topback" }, null, -1))
const _hoisted_7 = { class: "tubiao" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xuxian2" }, " 金黄色葡萄球菌能够释放大量存在超抗原特性的外毒素，引起疾病发生，并促进疾病恶化，导致炎性症状持续出现 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "backText" }, " 马瑶.湿疹皮炎患者并发皮肤细菌感染的病原菌分布与耐药性分析[J].抗感染药学, 2022, 19(5):711-713. ", -1))
const _hoisted_10 = { class: "bottomBox" }
const _hoisted_11 = {
  key: 0,
  class: "swperList"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ip" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, { show: true }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_image, {
              width: "7.8933rem",
              height: "5.6133rem",
              src: require('../assets/tubiao.png')
            }, null, 8, ["src"])
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_image, {
              onClick: $options.linchuang,
              width: "6.1067rem",
              height: "1.1333rem",
              src: require('../assets/adbtn.png')
            }, null, 8, ["onClick", "src"])
          ]),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_toNav, { menu: 1 })
  ], 64))
}